import { render, staticRenderFns } from "./PopupApprovalHistory.vue?vue&type=template&id=70de9f92&scoped=true"
import script from "./PopupApprovalHistory.vue?vue&type=script&lang=js"
export * from "./PopupApprovalHistory.vue?vue&type=script&lang=js"
import style0 from "./PopupApprovalHistory.vue?vue&type=style&index=0&id=70de9f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de9f92",
  null
  
)

export default component.exports